import React from 'react';
import PropTypes from 'prop-types';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { colors } from '../../../../constants/colors';
import styled, { css } from 'styled-components';
import { fontFamily, fontSize } from '../../../../constants/text';
import { smallerThanOrEqualTo, biggerThanOrEqualTo } from '../../../../core/util/styledComponents';

const StyledExpansionPanelSummary = styled(ExpansionPanelSummary)`
  border-top: 1px solid ${colors.dorianGrey};
  ${({ sc: { disableCursorPointer } }) =>
    disableCursorPointer &&
    css`
      cursor: unset !important;
    `};
  ${smallerThanOrEqualTo.md`
    border-top: none;
    &:before {
      content: '';
      background-color: ${colors.dorianGrey};
      height: 1px;
      position: absolute;
      top: 0;
      left: -15px;
      right: -15px;
    }
  `};
  padding: 0;
`;

const SectionTitle = styled.h2`
  color: ${colors.squid};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.extraLarge};
  line-height: 30px;
  padding-top: 13px;
  padding-bottom: 13px;
  margin-top: 0;
  margin-bottom: 0;
`;

const SlimExpansionPanelDetails = styled(ExpansionPanelDetails)`
  display: block;
  padding: 8px 0 24px;
`;

const StyledExpansionPanel = styled(ExpansionPanel)`
  box-shadow: none;
  &:before {
    content: unset;
    height: 0;
  }
`;

function PanelCard(props) {
  const { enableCollapsing, title, children, defaultExpanded } = props;
  const disableCursorPointer = !enableCollapsing;
  const shouldPanelStayExpanded = enableCollapsing ? undefined : true;

  return (
    <StyledExpansionPanel
      defaultExpanded={defaultExpanded}
      expanded={shouldPanelStayExpanded}
      classes={{ expanded: 'expanded' }}
    >
      <StyledExpansionPanelSummary
        sc={{ disableCursorPointer }}
        expandIcon={enableCollapsing ? <ExpandMoreIcon /> : null}
      >
        <SectionTitle>{title}</SectionTitle>
      </StyledExpansionPanelSummary>
      <SlimExpansionPanelDetails>{children}</SlimExpansionPanelDetails>
    </StyledExpansionPanel>
  );
}

PanelCard.propTypes = {
  classes: PropTypes.object,
  title: PropTypes.string.isRequired,
  enableCollapsing: PropTypes.bool,
  children: PropTypes.element.isRequired,
  defaultExpanded: PropTypes.bool,
};

PanelCard.defaultProps = {
  enableCollapsing: true,
};

export default PanelCard;
